var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { attrs: { name: "query-sort-block" } },
      [
        _c("swb-query-sort-area", {
          ref: "query_model_ctrl",
          attrs: {
            config: _vm.queryConfig,
            queryOnLoad: true,
            queryHandler: _vm.queryHandler
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.checkBox
      ? _c(
          "div",
          { staticClass: "table-layout" },
          [
            _c(
              "el-table",
              {
                ref: "mkuList",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.mkuList, border: "" },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _vm.checkBox
                  ? _c("el-table-column", {
                      attrs: {
                        selectable: _vm.selectable,
                        type: "selection",
                        width: "55"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "albumImg",
                    label: "图片",
                    width: "100"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.sku != null
                            ? _c("div", [
                                scope.row.sku.defaultImageUrl != null &&
                                scope.row.sku.defaultImageUrl != ""
                                  ? _c("img", {
                                      staticClass: "wh100",
                                      attrs: {
                                        src: scope.row.sku.defaultImageUrl
                                      }
                                    })
                                  : _c("img", {
                                      directives: [
                                        {
                                          name: "resc-url",
                                          rawName: "v-resc-url",
                                          value: "/image/noimg.jpg",
                                          expression: "'/image/noimg.jpg'"
                                        }
                                      ],
                                      staticClass: "wh100"
                                    })
                              ])
                            : _c("img", {
                                directives: [
                                  {
                                    name: "resc-url",
                                    rawName: "v-resc-url",
                                    value: "/image/noimg.jpg",
                                    expression: "'/image/noimg.jpg'"
                                  }
                                ],
                                staticClass: "wh100"
                              })
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "title",
                    label: "商品名称",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "cccFlag",
                    label: "是否3C",
                    align: "center",
                    width: "100"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.cccFlag
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: "success",
                                    "close-transition": ""
                                  }
                                },
                                [_vm._v("是")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !scope.row.cccFlag
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: "danger",
                                    "close-transition": ""
                                  }
                                },
                                [_vm._v("否")]
                              )
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "SKU商家编码",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [_c("span", [_vm._v(_vm._s(scope.row.sku.no))])]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "model",
                    label: "型号",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "fixedSpec",
                    label: "规格",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "catName",
                    label: "分类",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "brandName",
                    label: "品牌",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "shelfState",
                    label: "是否上架",
                    align: "center",
                    width: "100"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.shelfState == 0
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: "danger",
                                    "close-transition": ""
                                  }
                                },
                                [_vm._v("未上架")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.shelfState == 1
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: "success",
                                    "close-transition": ""
                                  }
                                },
                                [_vm._v("已上架")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.shelfState == -1
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: "danger",
                                    "close-transition": ""
                                  }
                                },
                                [_vm._v("已下架")]
                              )
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "table-layout" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.mkuList,
                  border: "",
                  "highlight-current-row": ""
                },
                on: { "current-change": _vm.handleCurrentChange }
              },
              [
                _c("el-table-column", {
                  attrs: { width: "55" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "copy-radio",
                              class: {
                                circle:
                                  _vm.checlMkuInfo != null &&
                                  _vm.checlMkuInfo.id == rows.row.id
                              }
                            },
                            [_c("div", { staticClass: "circle-dot" })]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "albumImg",
                    label: "图片",
                    width: "100"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.sku != null
                            ? _c("div", [
                                _c("img", {
                                  staticClass: "wh100",
                                  attrs: { src: scope.row.sku.defaultImageUrl }
                                })
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "title",
                    label: "商品名称",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "cccFlag",
                    label: "是否3C",
                    align: "center",
                    width: "100"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.cccFlag
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: "success",
                                    "close-transition": ""
                                  }
                                },
                                [_vm._v("是")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !scope.row.cccFlag
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: "danger",
                                    "close-transition": ""
                                  }
                                },
                                [_vm._v("否")]
                              )
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "SKU商家编码",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [_c("span", [_vm._v(_vm._s(scope.row.sku.no))])]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "model",
                    label: "型号",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "fixedSpec",
                    label: "规格",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "catName",
                    label: "分类",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "brandName",
                    label: "品牌",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "shelfState",
                    label: "是否上架",
                    align: "center",
                    width: "100"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.shelfState == 0
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: "danger",
                                    "close-transition": ""
                                  }
                                },
                                [_vm._v("未上架")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.shelfState == 1
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: "success",
                                    "close-transition": ""
                                  }
                                },
                                [_vm._v("已上架")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.shelfState == -1
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: "danger",
                                    "close-transition": ""
                                  }
                                },
                                [_vm._v("已下架")]
                              )
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pagination-layout" },
      [
        _c("el-pagination", {
          attrs: {
            background: "",
            "page-size": _vm.pageSize,
            "page-sizes": _vm.pageSizes,
            "current-page": _vm.pageNumber,
            total: _vm.totalCount,
            layout: "total, sizes, prev, pager, next, jumper"
          },
          on: {
            "current-change": _vm.handlePageChange,
            "size-change": _vm.handleSizeChange
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ad8cd2dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad8cd2dc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/goods/SkuListForSelect.vue
// module id = 1701
// module chunks = 1